import React from "react";
import { Avatar, Box, Chip } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ChipOutlinedSize = () => {
  const handleClick = () => {
    console.log("On Click");
  };
  const handleDelete = () => {
    console.log("On Delete");
  };

  return (
    <Box sx={{ mb: 2 }}>
      <PreviewAndEditor
        title={"Basic Outlined Chip Size"}
        language={"js"}
        value={"        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          size=\"medium\"\n" +
            "          label=\"Chip Medium\"\n" +
            "          onDelete={handleDelete}\n" +
            "          onClick={handleClick}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          size=\"small\"\n" +
            "          label=\"Chip Small\"\n" +
            "          onDelete={handleDelete}\n" +
            "          onClick={handleClick}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          size=\"xSmall\"\n" +
            "          label=\"Chip xSmall\"\n" +
            "          onDelete={handleDelete}\n" +
            "          onClick={handleClick}\n" +
            "        />"}
      >
        <Chip
          variant="outlined"
          avatar={<Avatar>H</Avatar>}
          size="medium"
          label="Chip Medium"
          onDelete={handleDelete}
          onClick={handleClick}
        />
        <Chip
          variant="outlined"
          avatar={<Avatar>H</Avatar>}
          size="small"
          label="Chip Small"
          onDelete={handleDelete}
          onClick={handleClick}
        />
        <Chip
          variant="outlined"
          avatar={<Avatar>H</Avatar>}
          size="xSmall"
          label="Chip xSmall"
          onDelete={handleDelete}
          onClick={handleClick}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default ChipOutlinedSize;
